import React from 'react';

import type { UIPublicAttribute } from 'src/adapters/storeToUI/adaptPublicAttributesToUI';
import { PRODUCT_DETAILS_HEADING } from 'src/components/layouts/PDP/copy';
import * as styles from './PublicAttributes.styles';

interface PublicAttributesProps {
  publicAttributes: UIPublicAttribute[];
}

export const PublicAttributes = ({ publicAttributes }: PublicAttributesProps) => {
  if (publicAttributes.length === 0) {
    return null;
  }

  return (
    <>
      <h2 css={styles.heading}>{PRODUCT_DETAILS_HEADING}</h2>
      <div css={styles.container}>
        {publicAttributes.map((attribute) => (
          <div css={styles.attributeItem} key={attribute.key}>
            <b>{attribute.title}</b>
            <span>{attribute.values.join(', ')}</span>
          </div>
        ))}
      </div>
    </>
  );
};
